import { z } from "zod";
/**
 * Per-tenant theme override schema.
 *
 * Canon: docs/design-canon/08-design/theming.md.
 *
 * Narrowed (2026-06-12, ADR-0072): a tenant may swap only the BRAND
 * ANCHOR — the teal family of tokens (brand / accent + their fg / deep /
 * hover / border / focus variants). Everything else (neutrals, status,
 * categories, sidebar) is fixed by the staff palette so cross-tenant
 * screens stay legible and consistent. Per-tenant identity beyond the
 * anchor is carried by the logo, not the colour system.
 *
 * Supplied as a partial override; missing keys fall back to the default
 * theme in tokens.ts. The object strips unknown keys, so any legacy
 * non-anchor override stored before this narrowing is ignored.
 *
 * Values must be CSS colour strings (hex / rgb / rgba / hsl / named).
 * The schema validates only the colour-string format, not contrast or
 * brand fitness — those are designer-side concerns.
 */
const cssColor = z
    .string()
    .min(3)
    .max(64)
    .regex(/^(?:#[0-9a-fA-F]{3,8}|rgba?\([^)]+\)|hsla?\([^)]+\)|[a-z]+)$/i, "must be a CSS colour value (hex, rgb, rgba, hsl, hsla, or named)");
export const TenantThemeSchema = z
    .object({
    // Brand anchor (the single swappable teal family)
    brand: cssColor,
    brandFg: cssColor,
    brandDeep: cssColor,
    accent: cssColor,
    accentFg: cssColor,
    accentHover: cssColor,
    fgBrand: cssColor,
    borderBrand: cssColor,
    focusRing: cssColor,
})
    .partial();
//# sourceMappingURL=tenant-theme.js.map